app.service('warrantyUpsellingBox', function (countdownTimer, validate, modal, message, loading, accountConfig, upsellingContext, upsellingWarranties, warrantyUpsellingConfigurator) {

	let $self, countdown;
	let config, isBoxExpanded = false,
		isWarrantyConfiguratorAvailable = false;

	function init() {

		setElements();

		if (!$self.length) {
			return;
		}

		if (isWarrantyConfiguratorAvailable) {
			warrantyUpsellingConfigurator.init();
		}

		if (upsellingContext.isActive()) {

			upsellingContext.clear();

			if (isWarrantyConfiguratorAvailable) {
				warrantyUpsellingConfigurator.show();
			} else {
				toggleWarrantyDetails();
			}
		}

		initCountDown();
		setEvents();
	}

	function setElements() {
		$self = $('#warranty-upselling-box');
		config = accountConfig.getData();
		isWarrantyConfiguratorAvailable = !!$self.data('configurator-available');
	}

	function initCountDown() {
		countdown = countdownTimer.create('.js-upselling-counter', {
			onEnd() {
				if (!isBoxExpanded && !warrantyUpsellingConfigurator.isActive()) {
					$self.hide();
				}
			}
		});
	}

	function setEvents() {
		if (isWarrantyConfiguratorAvailable) {
			$self.on("click", ".js-show-warranty-configurator", warrantyUpsellingConfigurator.show);
		} else {
			$self
				.on("click", ".js-show-warranty-details", toggleWarrantyDetails)
				.on("click", ".js-show-warranty-description", showWarrantyDescription)
				.on("click", ".js-user-settings", handleUserSettingsRedirect)
				.on("click", ".js-hide-warranty-details", toggleWarrantyDetails);

			validate.task('warrantyUpsellingForm', {
				$form: $('form', $self),
				submitHandler
			});
		}

	function submitHandler() {
		let data = {
			orderNumber: config.orderNumber,
			pesel: $self.find('#pesel').val()
		}

		loading.start();

		$.ajax({
			url: $('form', $self).attr('action'),
			method: 'POST',
			dataType: 'json',
			contentType: 'application/json',
			data: JSON.stringify(data)
		})
			.then(function (response) {
				if (response.status === "FAILURE") {
					if (response.failureReason === "RESERVATION_FAILURE") {
						loading.stop();

						message.get("subscription-warranty-upselling-reservation-error")
							.then(content => {
								modal.generate({
									id: 'reservation-failure-modal',
									content,
									callbackClose() {
										loading.reload();
									}
								})
							});
					}
					if (response.failureReason === "REGISTRATION_FAILURE") {
						loading.reload();
					}
				} else {
					upsellingWarranties.subscribeUpsellingWarranty(response.id);
				}
			})
			.fail(function () {
				loading.stop();
				modal.alert("Błąd wewnętrzny systemu.");
				});
			}


		$('body').on("click", ".js-warranty-back-button", () => modal.close());
	}

	function showWarrantyDescription() {
		modal.open('warranty-upselling-description');
	}

	function handleUserSettingsRedirect() {
		upsellingContext.setup();
		loading.redirect("/customer-password.bhtml");
	}

	function toggleWarrantyDetails() {
		isBoxExpanded = !isBoxExpanded;
		$self.toggleClass('is-expanded', isBoxExpanded);
	}

	return {
		init
	};
});